import { create } from "zustand";
import { persist } from "zustand/middleware";

interface CookieConsentState {
  hasConsented: boolean;
  setConsent: (value: boolean) => void;
}

const useCookieConsentStore = create<CookieConsentState>()(
  persist(
    (set) => ({
      hasConsented: false,
      setConsent: (value) => set({ hasConsented: value }),
    }),
    {
      name: "cookie-consent-storage",
    }
  )
);

export default useCookieConsentStore;
